import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";

export default function Inbound_CompletedPage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                inbound completed page
            </LayoutWithNavigationBar>
        </>
    );
}